import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '../../utils/baseQueryWithAuth';

// Create a single, unified API slice
export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['Brand', 'Catalog', 'Product', 'Seller', 'Order', 'PriceLog', 'Notification'],
  endpoints: () => ({}),
});
